import React, { useEffect, useState } from 'react';
import PageApp from '../../../Page';
import { HomeOutlined } from '@ant-design/icons';
import { Table, Empty, Form, Divider, Skeleton, Tabs, Typography, Tooltip } from 'antd';
import { obtenerAcumuladosPorPeriodo } from '../../../../apis/TimbradosPeriodoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import Currency from '../../../../components/common/Currency';

const { Text } = Typography;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  }
];

const AcumuladosPeriodoPage = () => {
  const [form] = Form.useForm();
  const [conceptos, setConceptos] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOkPeriodo = async () => {
    setLoading(true);
    try {
        const values = await form.validateFields();
        if (!values) return;
        
        const periodo_id = values.periodo_id;
        const anio = values.anio;
        const num_periodo = values.num_periodo;

        if (!periodo_id || !anio || !num_periodo) {
            console.log("Periodo, Año y Número de Periodo son requeridos.");
            setLoading(false);
            return;
        }
        const response = await obtenerAcumuladosPorPeriodo(periodo_id, anio, num_periodo);
        if (response.ok) {
            setConceptos(response.payload.conceptos || []);
        }
    } catch (errorInfo) {
        console.log('Failed:', errorInfo);
    } finally {
        setLoading(false);
    }
  };

  // Reorganizar datos: agrupar empleados únicos y crear mapeo concepto -> valor
  const transformDataForTabs = () => {
    if (conceptos.length === 0) return { empleados: [], conceptosClave: [] };

    const empleadosMap = new Map();
    const conceptosClave = [];

    // Recopilar todos los conceptos únicos
    conceptos.forEach((concepto) => {
      if (!conceptosClave.includes(concepto.clave)) {
        conceptosClave.push(concepto.clave);
      }

      // Recopilar empleados
      concepto.empleados.forEach((emp) => {
        if (!empleadosMap.has(emp.empleado_id)) {
          empleadosMap.set(emp.empleado_id, {
            empleado_id: emp.empleado_id,
            empleado_nombre: emp.empleado_nombre,
            conceptos: {}
          });
        }

        const empleado = empleadosMap.get(emp.empleado_id);
        empleado.conceptos[concepto.clave] = {
          monto: emp.monto,
          dias: emp.dias,
          horas: emp.horas,
          exento: emp.exento,
        };
      });
    });

    const empleados = Array.from(empleadosMap.values())
      .sort((a, b) => a.empleado_nombre.localeCompare(b.empleado_nombre));

    return { empleados, conceptosClave };
  };

  const getColumnsForTab = (field) => {
    const { empleados, conceptosClave } = transformDataForTabs();

    const baseColumns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado_nombre',
        key: 'empleado_nombre',
        width: 200,
        fixed: 'left',
      }
    ];

    const conceptoColumns = conceptosClave.map((clave) => {
      // Buscar el concepto completo para obtener descripción y tipo
      const conceptoInfo = conceptos.find(c => c.clave === clave);
      const descripcion = conceptoInfo ? `${conceptoInfo.descripcion} (${conceptoInfo.tipo_concepto})` : clave;

      return {
        title: (
          <Tooltip title={descripcion}>
            <span style={{ cursor: 'help' }}>{clave}</span>
          </Tooltip>
        ),
        dataIndex: ['conceptos', clave, field],
        key: `${clave}-${field}`,
        align: 'center',
        render: (value) => {
          if (value === undefined || value === null) return '-';
          if (field === 'monto' || field === 'exento') {
            return <Currency value={value} />;
          }
          return Number(value).toFixed(2);
        },
      };
    });

    return [...baseColumns, ...conceptoColumns];
  };

  const { empleados } = transformDataForTabs();

  return (
    <PageApp routes={routes} title={'Acumulados por Periodo'}>
      <Divider />
      <Form form={form} layout="horizontal" autoComplete="off">
        <AnioPeriodo 
          form={form}
          onBlur={handleOkPeriodo}
        />
      </Form>
      <Divider />
      {
        loading ? (
          <Skeleton active={loading} />
        ) : (
          <>
            {conceptos.length === 0 ? (
              <Empty description="No hay datos para este período" />
            ) : (
              <Tabs
                items={[
                  {
                    key: 'monto',
                    label: 'Monto',
                    children: (
                      <Table
                        dataSource={empleados}
                        columns={getColumnsForTab('monto')}
                        pagination={{ pageSize: 20 }}
                        size="small"
                        rowKey="empleado_id"
                        bordered
                        scroll={{ x: 'max-content' }}
                      />
                    ),
                  },
                  {
                    key: 'dias',
                    label: 'Días',
                    children: (
                      <Table
                        dataSource={empleados}
                        columns={getColumnsForTab('dias')}
                        pagination={{ pageSize: 20 }}
                        size="small"
                        rowKey="empleado_id"
                        bordered
                        scroll={{ x: 'max-content' }}
                      />
                    ),
                  },
                  {
                    key: 'horas',
                    label: 'Horas',
                    children: (
                      <Table
                        dataSource={empleados}
                        columns={getColumnsForTab('horas')}
                        pagination={{ pageSize: 20 }}
                        size="small"
                        rowKey="empleado_id"
                        bordered
                        scroll={{ x: 'max-content' }}
                      />
                    ),
                  },
                  {
                    key: 'exento',
                    label: 'Exento',
                    children: (
                      <Table
                        dataSource={empleados}
                        columns={getColumnsForTab('exento')}
                        pagination={{ pageSize: 20 }}
                        size="small"
                        rowKey="empleado_id"
                        bordered
                        scroll={{ x: 'max-content' }}
                      />
                    ),
                  },
                ]}
              />
            )}
          </>
        )
      }
    </PageApp>
  );
};

export default AcumuladosPeriodoPage;
